import accountRequest from './request/accountRequest';
import STORAGE_NAME from '@/const/storage';

function setToken() {
  const token = localStorage.getItem(STORAGE_NAME.ACCESS_TOKEN);
  if (token) accountRequest.setToken(token);
}

export const reportApi = {
  /**
   * GET /api/users/seller-report/store-by-account
   * Lấy danh sách store theo ngày (bảng bên phải)
   * @param {string} date - "YYYY-MM-DD"
   */
  getStoresByDate(date) {
    setToken();
    return accountRequest.get('/users/seller-report/store-by-account', {
      params: { date },
    });
  },

  /**
   * POST /api/users/seller-report/upsert
   * Upsert rev/order/spent cho 1 dòng
   * @param {{ date: string, store_id: string, rev: number, order: number, spent: number }} body
   */
  updateRow(body) {
    setToken();
    return accountRequest.post('/users/seller-report/upsert', body);
  },

  /**
   * POST /api/users/seller-report/next-plan
   * Lưu dự kiến ngày hôm sau
   * @param {{ plan: string }} body
   */
  saveNextPlan(body) {
    setToken();
    return accountRequest.post('/users/seller-report/next-plan', body);
  },

  /**
   * GET /api/users/seller-report/by-seller
   * Lấy tổng theo tháng & tổng theo ngày
   * @param {string} date - "YYYY-MM-DD" (ngày bất kỳ trong tháng)
   */
  getBySeller(date) {
    setToken();
    return accountRequest.get('/users/seller-report/by-seller', {
      params: { date },
    });
  },

  /**
   * GET /api/users/shared-prompt/by-seller
   * Lấy danh sách share prompt của seller trong khoảng ngày
   * @param {{ startDate: string, endDate: string, page: number, limit: number }} params
   */
  getSharedPromptBySeller(params) {
    setToken();
    return accountRequest.get('/users/shared-prompt/by-seller', {
      params,
    });
  },

  /**
   * GET /api/users/library-content/shared
   * Lấy danh sách content ads được share từ admin xuống
   * @param {{ search: string, page: string|number, limit: string|number }} params
   */
  getLibraryContentShared(params) {
    setToken();
    return accountRequest.get('/users/library-content/shared', { params });
  },

  /**
   * POST /ap/users/add-fee-detail-by-store-v2
   * Add fee by store v2
   * @param {{ adsFee: string, accountId: string, storeId: number, date: number }} params
   */
  addFeeDetailByStoreV2(params) {
    setToken();
    return accountRequest.post('/users/add-fee-detail-by-store-v2', params);
  },

  /**
   * GET /api/users/ads-accounts/account-available
   * Get available accounts
   * @param {{ page: number, limit: number, accountName: string }} params
   */
  getAdsAccountsAvailable(params) {
    setToken();
    return accountRequest.get('/users/ads-accounts/account-available', { params });
  },

  /**
   * GET /api/users/report-catalog/by-seller
   * Lấy danh sách catalog với spent / revenue / order theo ngày
   * @param {{ page: string|number, limit: string|number, date: string }} params
   */
  getReportCatalogBySeller(params) {
    setToken();
    return accountRequest.get('/users/report-catalog/by-seller', { params });
  },

  /**
   * GET /api/users/report-catalog/by-manage-seller
   * Lấy báo cáo catalog của tất cả seller mà 1 SALE_MANAGER quản lý
   * @param {{ timeStart: string, timeEnd: string }} params - "YYYY-MM-DD"
   */
  getReportCatalogByManageSeller(params) {
    setToken();
    return accountRequest.get('/users/report-catalog/by-manage-seller', { params });
  },

  /**
   * GET /api/users/report-catalog/list-not-map
   * Lấy danh sách campaign chưa được map với product
   * @param {{ page: string|number, limit: string|number }} params
   */
  getReportCatalogListNotMap(params) {
    setToken();
    return accountRequest.get('/users/report-catalog/list-not-map', { params });
  },

  /**
   * GET /api/users/report-catalog/list-product
   * Lấy danh sách product để map với campaign
   * @param {{ page: string|number, limit: string|number, product_name: string }} params
   */
  getReportCatalogListProduct(params) {
    setToken();
    return accountRequest.get('/users/report-catalog/list-product', { params });
  },

  /**
   * GET /api/users/report-catalog/list-shopify-product
   * Lấy danh sách shopify product để map với campaign
   * @param {{ page: string|number, limit: string|number, product_name: string }} params
   */
  getReportCatalogListShopifyProduct(params) {
    setToken();
    return accountRequest.get('/users/report-catalog/list-shopify-product', { params });
  },

  /**
   * POST /api/users/report-catalog/save-map-product
   * Lưu map giữa campaign và product
   * @param {{ campaign_id: string, product_id: string }} body
   */
  saveMapProduct(body) {
    setToken();
    return accountRequest.post('/users/report-catalog/save-map-product', body);
  },

  /**
   * POST /api/users/report-catalog/save-map-shopify-product
   * Lưu map giữa campaign và shopify product
   * @param {{ post_id: string, product_id: string }} body
   */
  saveMapShopifyProduct(body) {
    setToken();
    return accountRequest.post('/users/report-catalog/save-map-shopify-product', body);
  },

  /**
   * POST /api/users/seller-report/note-catalog-seller
   * Lưu note cho catalog theo ngày
   * @param {{ catalogId: string, date: string, note: string }} body
   */
  saveNoteCatalogSeller(body) {
    setToken();
    return accountRequest.post('/users/seller-report/note-catalog-seller', body);
  },

  /**
   * GET /api/users/report-ads/by-seller
   * Lấy báo cáo Ads Report
   */
  getReportAdsBySeller(params) {
    setToken();
    return accountRequest.get('/users/report-ads/by-seller', { params });
  },
};
